import { render, staticRenderFns } from "./bind_wechat.vue?vue&type=template&id=5b0f86d8&scoped=true"
import script from "./bind_wechat.vue?vue&type=script&lang=js"
export * from "./bind_wechat.vue?vue&type=script&lang=js"
import style0 from "./bind_wechat.vue?vue&type=style&index=0&id=5b0f86d8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0f86d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0f86d8')) {
      api.createRecord('5b0f86d8', component.options)
    } else {
      api.reload('5b0f86d8', component.options)
    }
    module.hot.accept("./bind_wechat.vue?vue&type=template&id=5b0f86d8&scoped=true", function () {
      api.rerender('5b0f86d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/user_management/form/add_user/components/bind_wechat.vue"
export default component.exports